import { IUntypedQuery, Topics } from '@zaplify/common';

export class GetPersonsByIdsIdQuery extends IUntypedQuery {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly personIds: string[], readonly userId?: string, readonly organizationId?: string) {
        super();
    }
}
